import * as React from 'react';
import { Modal, XFilledIcon, Table, Toolbar, Button } from 'react-unity';
import OnPremWorkflowInstanceState from '../../../models/WorkflowInstanceState';
import './WorkflowHistoryModal.css';

interface WorkflowHistoryModalProps {
    visible: boolean;
    onClose: (event: React.ChangeEvent<any>) => void;
    workflowInstanceStates: OnPremWorkflowInstanceState[];
}

interface WorkflowHistoryModalState {
    statesOnPage: OnPremWorkflowInstanceState[];
}

export default class WorkflowHistoryModal extends React.Component<WorkflowHistoryModalProps, WorkflowHistoryModalState> {
    constructor(props: WorkflowHistoryModalProps) {
        super(props);
        this.state = {
            statesOnPage: [],
        };
    }

    render() {
        const tableRows = [...this.props.workflowInstanceStates]
            .reverse()
            .map((state) => (
                <Table.Body.Row key={state.workflowInstanceId}>
                    <Table.Body.Cell>{state.performedOnDate ? new Date(state.performedOnDate).toLocaleString() : 'N/A'}</Table.Body.Cell>
                    <Table.Body.Cell>
                        {state.action ? state.action.charAt(0).toUpperCase() + state.action.slice(1) : ''}
                    </Table.Body.Cell>
                    <Table.Body.Cell>{state.performedByUser?.displayName}</Table.Body.Cell>
                    <Table.Body.Cell>
                        {state.performedReason ? state.performedReason.charAt(0).toUpperCase() + state.performedReason.slice(1) : ''}
                    </Table.Body.Cell>
                    <Table.Body.Cell>{state.workflowState?.name}</Table.Body.Cell>
                </Table.Body.Row>
            ));

        return (
            <Modal show={this.props.visible} onHide={() => { }}>
                <Modal.Window id="WorkflowHistoryModal" className="em-u-margin-double">
                    <Modal.Window.Header>
                        <Modal.Window.Header.Title>Workflow History</Modal.Window.Header.Title>
                        <Modal.Window.Header.CloseButton onClick={this.props.onClose}>
                            <XFilledIcon size="small" />
                        </Modal.Window.Header.CloseButton>
                    </Modal.Window.Header>
                    <Modal.Window.Body>
                        <Table>
                            <Table.Head>
                                <Table.Head.Row>
                                    <Table.Head.Cell>Date</Table.Head.Cell>
                                    <Table.Head.Cell>Action</Table.Head.Cell>
                                    <Table.Head.Cell>Performed By</Table.Head.Cell>
                                    <Table.Head.Cell>Comment</Table.Head.Cell>
                                    <Table.Head.Cell>Send to</Table.Head.Cell>
                                </Table.Head.Row>
                            </Table.Head>
                            <Table.Body>{tableRows}</Table.Body>
                        </Table>
                    </Modal.Window.Body>
                </Modal.Window>
            </Modal>
        );
    }
}
